import { Component } from '@angular/core';

@Component({
  selector: 'app-web-full-page-layout',
  imports: [],
  templateUrl: './web-full-page-layout.component.html',
  styleUrl: './web-full-page-layout.component.scss'
})
export class WebFullPageLayoutComponent {

}
